import { parseImageId as e } from "./parseImageId.es.js";
// lib/TTVisual/lib/consumes.ts
var t = ({ input: t }) => {
	let { type: n, data: r } = t;
	return typeof r == "string" && [
		"tt/visual",
		"text/uri-list",
		"text/plain"
	].includes(n) && e(r) ? [!0, "tt/visual"] : [!1];
};
export { t as consumes };
